import React from 'react'
import { storiesOf } from '@storybook/react'

import SelectFriends from 'components/SelectFriends'
import { Omit, MessageHandler } from 'types'
import { IUser, FriendsResponse, GameDetailsResponse } from 'protos'
import noop from 'lodash-es/noop'
import { withRouter } from 'react-router'
import InviteMoreFriendsScreen from 'routes/InviteMoreFriends/InviteMoreFriendsScreen'
import SelectFriendsScreen from 'routes/SelectFriends/SelectFriendsScreen'

// fake data

const fakeUserFriendsResponse = FriendsResponse.fromObject({
  friend: [
    { userId: 'xaa', name: 'Jane Doe', photoUrl: 'http://i.pravatar.cc/128?img=1', facebookFriend: true },
    { userId: 'xab', name: 'John Doe', photoUrl: 'http://i.pravatar.cc/128?img=2' },
    { userId: 'xac', name: 'Kecel Rulz', photoUrl: 'http://i.pravatar.cc/128?img=3' },
  ],
  request: [],
  facebookStatus: FriendsResponse.FacebookStatus.FBS_NO_TOKEN,
  facebookCount: 0,
})

const fakeGameDetailsResponse = GameDetailsResponse.fromObject({ })

const fakeStream = <T extends object>(message: T, errorCode?: string) =>
  (
    onmessage: MessageHandler<T>,
    onerror: MessageHandler<Error>,
  ) => {
    if (errorCode) {
      onerror(new Error(errorCode))
    } else {
      onmessage(message)
    }
    return noop
  }

// stories

const stories = storiesOf('SelectFriendsScreen', module)

stories
  .add('SelectFriendsScreen', () => {
    const SelectFriendsContainer = withRouter(SelectFriendsScreen)

    return (
      <SelectFriendsContainer
        getUserFriends={() => Promise.resolve(fakeUserFriendsResponse)}
        selectedFriendIds={new Set()}
        onFriendSelect={noop}
        onFriendDeselect={noop}
        onFriendsSubmit={noop}
      />
    )
  })
  .add('InviteMoreFriendsScreen', () => (
    <InviteMoreFriendsScreen
      getGameDetails={() => fakeStream(fakeGameDetailsResponse)}
      getUserFriends={() => Promise.resolve(fakeUserFriendsResponse)}
      selectedFriendIds={new Set()}
      onFriendSelect={noop}
      onFriendDeselect={noop}
      onFriendsSubmit={noop}
      clearError={noop}
    />
  ))
  .add('SelectFriends', () => {
    type Props = {
      initialSelectedFriendIds?: Array<string>
    } & Omit<React.ComponentProps<typeof SelectFriends>, 'selectedFriendIds' | 'onFriendSelect' | 'onFriendDeselect'>

    type State = {
      selectedFriendIds: Array<string>
    }

    class SelectFriendsContainer extends React.Component<Props, State> {
      constructor(props: Props) {
        super(props)
        this.state = { selectedFriendIds: props.initialSelectedFriendIds || [] }
      }

      onFriendSelect = (friend: IUser) => {
        this.setState((state) =>
          ({ selectedFriendIds: [...state.selectedFriendIds, friend.userId!] })
        )
      }

      onFriendDeselect = (friend: IUser) => {
        this.setState((state) =>
          ({ selectedFriendIds: state.selectedFriendIds.filter(friendId => friend.userId !== friendId) })
        )
      }

      render() {
        return (
          <SelectFriends
            {...this.props}
            selectedFriendIds={new Set(this.state.selectedFriendIds)}
            onFriendSelect={this.onFriendSelect}
            onFriendDeselect={this.onFriendDeselect}
          />
        )
      }
    }

    return (
      <SelectFriendsContainer
        friends={fakeUserFriendsResponse.friend}
        invitedFriendIds={new Set(['xab'])}
      />
    )
  })
